var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReopen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.445 13.3834C15.74 14.8088 14.5965 15.9707 13.1825 16.6984C11.7786 17.4192 10.178 17.6626 8.62333 17.3917C7.06383 17.1175 5.63505 16.3457 4.55084 15.1917C3.45656 14.0268 2.75984 12.545 2.56084 10.9592C2.35871 9.36982 2.66316 7.75718 3.43084 6.35087C4.19146 4.95535 5.38007 3.84092 6.82167 3.17171C8.25359 2.50851 9.8628 2.33062 11.405 2.66504C12.9467 2.99921 14.21 3.75921 15.255 4.96087C15.3808 5.09421 15.8675 5.63254 16.2717 6.44504",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5576 6.51087L16.7576 7.2667L17.5001 2.9917",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReopen);
export default __webpack_public_path__ + "static/media/reopen.982c174ee5ea3af6f728f2be3ff8043a.svg";
export { ForwardRef as ReactComponent };